// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://vbdcbjfmpdojeppzypat.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZiZGNiamZtcGRvamVwcHp5cGF0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzUyMjYxMDIsImV4cCI6MjA1MDgwMjEwMn0.ZQcl7iVotmjtFku2S5OVjddfQ6gAVuk97jGe6jJonZw";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);